import React from "react";
const GraphqlRequestConfigContext = React.createContext({});
const { Provider: GraphqlRequestConfigContextProvider } = GraphqlRequestConfigContext;
const useGraphqlRequestConfigContext = () => React.useContext(GraphqlRequestConfigContext);
export {
  GraphqlRequestConfigContextProvider,
  useGraphqlRequestConfigContext
};
